var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "64.000000pt",
    height: "64.000000pt",
    viewBox: "0 0 64.000000 64.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,64.000000) scale(0.100000,-0.100000)",
    fill: "#C34271",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356 450 c-114 -112 -123 -123 -138 -180 -9 -33 -13 -62 -9 -64 4 -3 32 2 62 11 48 13 68 29 177 136 132 132 141 149 97 192 -42 43 -59 34 -189 -95z m178 68 c14 -20 14 -24 1 -37 -13 -14 -18 -13 -41 11 -15 14 -23 31 -20 37 12 18 44 12 60 -11z m-57 -40 c13 -12 23 -26 23 -32 0 -14 -162 -176 -176 -176 -6 0 -21 11 -34 25 l-24 26 89 89 c49 50 92 90 94 90 3 0 15 -10 28 -22z m-192 -208 c17 -18 16 -19 -9 -26 -33 -8 -40 -2 -31 25 8 26 17 26 40 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 500 c-19 -19 -20 -33 -20 -205 0 -172 1 -186 20 -205 19 -19 33 -20 218 -20 239 0 232 -4 232 114 0 49 -4 75 -10 71 -5 -3 -10 -33 -10 -65 0 -96 15 -90 -211 -90 -186 0 -199 1 -209 19 -6 11 -10 90 -10 184 0 195 1 197 98 197 35 0 62 4 62 10 0 6 -30 10 -70 10 -57 0 -74 -4 -90 -20z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c4bca22b6983bca6d1cc078b214ccab7.svg";
export { ForwardRef as ReactComponent };